
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aydinlatma-metni",
      function () {
        return require("private-next-pages/aydinlatma-metni.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aydinlatma-metni"])
      });
    }
  